<!-- src/components/NewsList.vue -->
<template>
    <div class="news-list-container">
        <div class="news-list">
            <h3>新闻资讯</h3>
            <ul>
                <li v-for="news in newsList" :key="news.id" @click="goToDetail(news.id)">
                    <div class="news-item">
                        <div class="news-date">
                            <div>{{ news.date.split('-')[0] }}</div>
                            <div>{{ news.date.split('-')[1] }}-{{ news.date.split('-')[2] }}</div>
                        </div>
                        <div class="news-content">
                            <span>{{ news.title }}</span>
                            <p>{{ news.contentSnippet }}</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            newsList: [
// 这里的顺序决定显示的顺序
                { id: 13, date: '2024-06-27', title: '韩国艾乐肤化妆品株式会社最新公告' },
                { id: 12, date: '2024-06-20', title: '声明函' },

                { id: 4, date: '2024-06-04', title: '授权书' },

                { id: 1, date: '2024-05-22', title: '韩国艾乐肤化妆品株式会社声明函' },
                { id: 2, date: '2024-05-22', title: '终止授权通知函（韩国艾乐肤化妆品株式会社发给浙江艾乐肤生物科技有限公司）' },
                { id: 3, date: '2024-05-22', title: '终止授权通知函（韩国艾乐肤化妆品株式会社发给青岛艾乐肤化妆品有限公司）' },

                
                { id: 6, date: '2024-05-22', title: '一份2022年授权的声明书' },
                { id: 5, date: '2024-05-22', title: '韩国艾乐肤化妆品株式会社发出了中国区的新授权书' },
                // { id: 6, date: '2024-05-22', title: '商标使用许可终止通知书（韩国艾乐肤化妆品株式会社发给青岛艾乐肤化妆品有限公司）' },
                
                
                { id: 11, date: '2024-05-22', title: '合同解除通知函（韩国艾乐肤化妆品株式会社发给山东瑶华网络科技有限公司）' },
                { id: 10, date: '2024-05-22', title: '合同解除通知函（韩国艾乐肤化妆品株式会社发给山东八月初网络科技有限公司第一分公司）' },
                { id: 9, date: '2024-05-22', title: '合同解除通知函（韩国艾乐肤化妆品株式会社发给山东八月初网络科技有限公司）' },
                

                { id: 8, date: '2024-05-22', title: '合同解除通知函（邹鲁波发给中国人民共和国人刘进华）' },
                { id: 7, date: '2024-05-22', title: '合同解除通知函（韩国艾乐肤化妆品株式会社发给中国人民共和国人刘进华）' },
                
                
            ]
        };
    },
    methods: {
        goToDetail (newsId) {
            this.$router.push({ name: 'NewsDetail', params: { id: newsId } });
        }
    }
};
</script>

<style >
/* 桌面端 */
@media only screen and (min-width: 996px) {
    .news-list {
    width: 60%;
}
}
/* 移动端 */
@media only screen and (max-width: 996px) {
    .news-list {
    width: 100%;
}
}
.news-list-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-top: 100px;
    padding: 20px;
}



.news-list ul {
    list-style: none;
    padding: 0;
}

.news-list li {
    margin-bottom: 20px;
}

.news-list h3 {
    text-align: center;
    margin-bottom: 80px;
    /* 例如这里设置为 20px */
}


.news-item {
    display: flex;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    transition: background-color 0.3s;
}

.news-item:hover {
    background-color: #f5f5f5;
}

.news-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80px;
    padding-right: 15px;
    border-right: 1px solid #ccc;
    font-size: 14px;
    color: #888;
}

.news-content {
    flex: 1;
    padding-left: 15px;
    display: flex;
    align-items: center;
}

.news-content h3 {
    margin: 0 0 10px;
    font-size: 18px;
    font-weight: bold;
}

.news-content span {
    font-size: 16px;
    line-height: 26px;
    font-weight: 500;
    color: #000;
}

.news-content p {
    margin: 0;
    font-size: 13px;
    color: #717171;
    line-height: 23px;
}</style>
